// services/api/studentService.js
import API from '../api/api';

export const announcementService = {
  getAnnouncments: async (location_ids, program_ids) => {
    const response = await API.get('/get_announcements', {params: { location_ids, program_ids }});
    return response.data.data || [];
  },
  getAnnouncmentAck: async (announcement_id) => {
    const response = await API.get('/get_announcements_ack', { params: { announcement_id }});
    return response.data.data || [];
  },
  ackAnnouncments: async (announcement_id) => {
    let response = await API.post('/announcement_ack', { announcement_id });
    return response.data;
  },
  createAnnouncement: async (payload) => {
    const response = await API.post('/create_announcement', payload);
    return response.data;
  },
  
  updateAnnouncement: async (payload) => {
    const response = await API.post('/update_announcement', payload);
    return response.data;
  },
  deleteAnnouncement: async (id) => {
    const response = await API.post('/delete_announcement', {id});
    return response.data;
  }
  
};


